import React from "react";
import Tooltip from "./Tooltip";

function IconButton({ label, children, active = false, className = "", tooltip, ...rest }) {
  const button = (
    <button
      type="button"
      aria-label={label}
      title={tooltip ? undefined : label}
      className={["icon-btn", active ? "icon-btn-active" : "", className].filter(Boolean).join(" ")}
      {...rest}
    >
      {children}
    </button>
  );

  if (!tooltip) return button;
  return <Tooltip label={tooltip}>{button}</Tooltip>;
}

export default IconButton;
